export const TEAM_MEMBERS_QUERY_KEY = () => ["team-members"];
export const SOCIAL_MEDIA_QUERY_KEY = () => ["social-media"];
